import React, { Fragment, useState, useEffect } from 'react'; // eslint-disable-next-line
import { Row, Col, Card, CardBody, CardHeader, Button, Image } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriPortalRequest, getLanguagePackUrl, copiriAxiosPost } from '../api/api';
import config from '../config/config';
import Loader from '../common/Loader';
import ElectionVotingAboutStart from './ElectionVotingAboutStart';
import ElectionProjectionOpen from './ElectionProjectionOpen';
import ElectionVotingClosed from './ElectionVotingClosed';
import PollProjection from './PollProjection';
import './voting.css'; // eslint-disable-next-line
import { useParams } from 'react-router-dom';
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const Voting = () => {
	// eslint-disable-next-line
	const [pageLanguageContent, setPageLanguageContent] = useState([]);
	const [showHideLoader, setShowHideLoader] = useState(true);
	const [votingStep, setVotingStep] = useState('');
	const [votingData, setVotingData] = useState([]);
	const { id } = useParams();
	useEffect(() => {
		/* get Language packe data */
		getLanguagePack();
		/* call fucntion to get the status of voting */
		getVotingStatus(id);
		const intervalId = setInterval(() => {
			getVotingStatus(id);
		}, 5000); // 5000 milliseconds = 5 seconds

		// 3. Clean up the interval when the component unmounts
		return () => clearInterval(intervalId);
		// eslint-disable-next-line
	}, []);

	/* fucntion to get the status of voting */
	function getVotingStatus(contestId) {
		copiriPortalRequest('/voting/contests/' + contestId + '/display', config.app_version, 'get')
			.then(response => {
				setShowHideLoader(false);
				if (response?.data?.status) {
					setVotingStep(response?.data?.status);
					//setVotingStep('open');
				} else {
					setVotingStep('draft');
				}
				//setVotingStep('open');
				setVotingData(response?.data);
			})
			.catch(error => {
				alert(genPageData['GENDNF'] ? genPageData['GENDNF'] : '');
				setShowHideLoader(false);
			});
	}

	/* fucntion to get the language translation text */
	function getLanguagePack() {
		const formdata = new FormData();
		formdata.append('action', 'my_profile');
		copiriAxiosPost(config.portal_url, formdata)
			.then(response => {})
			.catch(error => {});
		setShowHideLoader(true);
		var checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData === null || checkData === undefined || checkData === '') {
			var getLanguageURL = getLanguagePackUrl();
			copiriPortalRequest(getLanguageURL, config.app_version, 'get')
				.then(response => {
					setShowHideLoader(false);
					if (response.data.result.VOT) {
						setPageLanguageContent(response.data.result.VOT);
					}
					localStorage.setItem('idiom', JSON.stringify(response.data.result));
				})
				.catch(error => {
					setShowHideLoader(false);
				});
		} else {
			if (checkData.VOT) {
				setPageLanguageContent(checkData.VOT);
			}
		}
	}

	/* function to show next page */
	// eslint-disable-next-line
	const showNextPage = () => {
		if (votingStep === 'pending') {
			setVotingStep('open');
		}
		if (votingStep === 'open') {
			setVotingStep('closed');
		}
		if (votingStep === 'closed') {
			setVotingStep('draft');
		}
		if (votingStep === 'draft') {
			setVotingStep('published');
		}
		if (votingStep === 'published') {
			setVotingStep('pending');
		}
	};

	return (
		<Fragment>
			{showHideLoader ? (
				<Loader />
			) : (
				<Card className='mt-3 mt-lg-0 w-100'>
					<CardBody className='p-0 fontInter'>
						{votingStep && votingStep === 'pending' && (
							<ElectionVotingAboutStart pageLanguageContent={pageLanguageContent} votingData={votingData} />
						)}
						{votingStep && votingStep === 'open' && (
							<ElectionProjectionOpen pageLanguageContent={pageLanguageContent} votingData={votingData} />
						)}
						{votingStep && votingStep === 'closed' && (
							<ElectionVotingClosed pageLanguageContent={pageLanguageContent} votingData={votingData} />
						)}
						{votingStep && votingStep === 'draft' && (
							<ElectionVotingAboutStart pageLanguageContent={pageLanguageContent} votingData={votingData} />
						)}
						{votingStep && votingStep === 'published' && (
							<PollProjection pageLanguageContent={pageLanguageContent} votingData={votingData} />
						)}
					</CardBody>
				</Card>
			)}
		</Fragment>
	);
};
export default Voting;
